module.exports = __webpack_public_path__ + "static/coworker2-ae50bb47a9726a50a57b453cde3fbc54.png";